import {
  FETCH_DEALER_ENTITLEMENTS,
  GET_DEALER_ENTITLEMENT,
  FETCH_DEALER_CREDIT_TRANSACTIONS,
  FETCH_DEALERS,
  GET_DEALER,
  UPDATE_DEALER,
  FETCH_DEALER_BRANCHES,
} from 'actions/dealerEntitlement';
import { toast } from 'react-toastify';
import _ from 'lodash';

const initialState = {
  isLoading: false,
  results: [],
  entitlementDetail: {},
  // Cards start at zero so the tab renders before the first response lands.
  stats: {
    total: 0,
    pending: 0,
    active: 0,
    unclaimed: 0,
    needs_review: 0,
    unresolved_location: 0,
  },
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 0,
  transactions: [],
  // Grouped by meaning: balances are point-in-time, movements follow the filters.
  transactionStats: { balance: {}, movement: {}, this_year: {} },
  dealerBreakdown: [],
  dealers: [],
  dealerDetail: {},
  branches: [],
  txPage: 1,
  txLimit: 10,
  txTotalPages: 1,
  txTotal: 0,
};

const dealerEntitlementReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_DEALER_ENTITLEMENTS.REQUEST:
    case FETCH_DEALER_CREDIT_TRANSACTIONS.REQUEST:
    case GET_DEALER.REQUEST:
    case UPDATE_DEALER.REQUEST:
    case FETCH_DEALER_BRANCHES.REQUEST:
    case GET_DEALER_ENTITLEMENT.REQUEST: {
      return { ...state, isLoading: true };
    }

    case FETCH_DEALER_ENTITLEMENTS.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        results: _.get(payload, 'results', []),
        stats: _.get(payload, 'stats', initialState.stats),
        page: _.get(payload, 'page', 1),
        limit: _.get(payload, 'limit', 10),
        totalPages: _.get(payload, 'totalPages', 1),
        total: _.get(payload, 'totalResults', 0),
      };
    }

    case FETCH_DEALER_CREDIT_TRANSACTIONS.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        transactions: _.get(payload, 'results', []),
        transactionStats: _.get(payload, 'stats', initialState.transactionStats),
        dealerBreakdown: _.get(payload, 'dealer_breakdown', []),
        txPage: _.get(payload, 'page', 1),
        txLimit: _.get(payload, 'limit', 10),
        txTotalPages: _.get(payload, 'totalPages', 1),
        txTotal: _.get(payload, 'totalResults', 0),
      };
    }

    case GET_DEALER.SUCCESS:
    case UPDATE_DEALER.SUCCESS: {
      return { ...state, isLoading: false, dealerDetail: payload };
    }

    case FETCH_DEALER_BRANCHES.SUCCESS: {
      return { ...state, isLoading: false, branches: _.isArray(payload) ? payload : [] };
    }

    case FETCH_DEALERS.SUCCESS: {
      return { ...state, isLoading: false, dealers: _.isArray(payload) ? payload : [] };
    }

    case GET_DEALER_ENTITLEMENT.SUCCESS: {
      return { ...state, isLoading: false, entitlementDetail: payload };
    }

    case FETCH_DEALER_ENTITLEMENTS.FAIL:
    case FETCH_DEALER_CREDIT_TRANSACTIONS.FAIL:
    case FETCH_DEALERS.FAIL:
    case GET_DEALER.FAIL:
    case UPDATE_DEALER.FAIL:
    case FETCH_DEALER_BRANCHES.FAIL:
    case GET_DEALER_ENTITLEMENT.FAIL: {
      const message = _.get(payload, 'error.response.data.message');
      message && toast.error(message);
      return { ...state, isLoading: false };
    }

    default:
      return state;
  }
};

export default dealerEntitlementReducer;
